import { LENDAPI_COMBINED_FUNNEL_FROM_PARAM, MY_APPLICATIONS_PATH } from '../constants';

export function isFromLendAPICombinedFunnel(search: string): boolean {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  return params.get('from') === LENDAPI_COMBINED_FUNNEL_FROM_PARAM;
}

export function getLogoutPageRedirectPath(search: string): string {
  return isFromLendAPICombinedFunnel(search)
    ? `${MY_APPLICATIONS_PATH}?from=${LENDAPI_COMBINED_FUNNEL_FROM_PARAM}`
    : '/';
}
